import React from "react";
import { CaresSeverity } from "../types";
import "./SeverityPicker.css";

interface SeverityPickerProps {
  value?: CaresSeverity;
  onChange: (value: CaresSeverity) => void;
}

const OPTIONS: CaresSeverity[] = ["Low", "Medium", "High", "Critical"];

const SeverityPicker: React.FC<SeverityPickerProps> = ({ value, onChange }) => {
  return (
    <div className="mrc-severity" role="radiogroup" aria-label="Severity">
      {OPTIONS.map((option) => (
        <button
          key={option}
          type="button"
          role="radio"
          aria-checked={value === option}
          className={`mrc-severity__option mrc-severity__option--${option.toLowerCase()}${
            value === option ? " mrc-severity__option--active" : ""
          }`}
          onClick={() => onChange(option)}
        >
          {option}
        </button>
      ))}
    </div>
  );
};

export default SeverityPicker;
